import React from "react";
import dynamic from "next/dynamic";
import Image from "next/image";
const ButtonLink = dynamic(() => import("@/Components/ButtonLink"),{ssr: true});

interface InsightsBlueProps {
  title: string;
  date: string;
  link: string;
  linkLabel?: string;
}

const InsightsBlue: React.FC< InsightsBlueProps> = ({ title,
  date,
  link,
  linkLabel = "Read more",
 }) => {
  // Format the date to 'Month Day, Year' (e.g., 'June 10, 2025')
  let formattedDate = "";
  if (date) {
    const parsedDate = new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      formattedDate = parsedDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } else {
      formattedDate = date; // fallback to original if parsing fails
    }
  }
  return (
    <div className="relative md:p-6 p-4 md:pt-20 pt-5 h-full flex flex-col justify-end items-start bg-[#CDE5FC] min-h-[190px] overflow-hidden">
      {/* Background image wrapper */}
      <div className="absolute inset-0">
        <Image
          src="/images/Insights-blue.webp"
          alt="Insights background"
          fill
          className="object-cover object-center"
          sizes="100vw"
          priority
        />
      </div>

      {/* Decorative overlay image (bottom-left) */}
      <div className="absolute inset-0">
        <Image
          src="/images/Insights-blue-left.webp"
          alt="Decorative overlay"
          fill
          className="object-contain object-left-bottom"
          sizes="100vw"
          priority
        />
      </div>

      <div className="relative z-10">
        <h5 className="text-heading-5 font-bold text-primary-text line-clamp-3 xl:leading-[45px]! lg:leading-[45px]! leading-[35px]!">
          {title || ""}
        </h5>
        <div className="w-full flex justify-between items-center mt-5">
          <p className="text-secondary-text text-subtitle-3 font-regular">
            {formattedDate || ""}
          </p>
          {link && linkLabel && (
            <ButtonLink
              href={link}
              label={linkLabel}
              color="text-primary-text"
              stroke="stroke-primary-text"
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default InsightsBlue;